import { getPropsFromNode, nodeIs } from '../utils'
import { h } from '../parser/utils'
import {
  ArticleHeading1,
  ArticleHeading2,
  ArticleHeading3,
  ArticleHeading4,
  ArticleHeading5,
  ArticleHeading6,
} from '../../components/molecule/ArticleContent/entry'

const COMPONENT_MAPPING = {
  h1: ArticleHeading1,
  h2: ArticleHeading2,
  h3: ArticleHeading3,
  h4: ArticleHeading4,
  h5: ArticleHeading5,
  h6: ArticleHeading6,
}

export const NAME = 'heading'

export const COMPONENTS = {
  ArticleHeading1,
  ArticleHeading2,
  ArticleHeading3,
  ArticleHeading4,
  ArticleHeading5,
  ArticleHeading6,
}

export function matches(node) {
  return nodeIs(node, ...Object.keys(COMPONENT_MAPPING))
}

export async function transform(node, next, ctx) {
  const Component = COMPONENT_MAPPING[node.nodeName.toLowerCase()]

  const children = await next(node.childNodes, ctx)

  const props = getPropsFromNode(node)

  return h(Component, props, ...children)
}
